import React from 'react';
import MultiSelect from '@/components/ui/multi-select';
import { LazySection } from '@/components/ui/LazySection';

interface ProviderFilterBarProps {
  countryOptions: string[];
  technologyOptions: { id: string; name: string }[];
  productTypeOptions: { id: string; name: string }[];
  platformOptions: { id: string; name: string }[];
  selectedCountries: string[];
  setSelectedCountries: (v: string[]) => void;
  selectedTechnologies: string[];
  setSelectedTechnologies: (v: string[]) => void;
  selectedProductTypes: string[];
  setSelectedProductTypes: (v: string[]) => void;
  selectedPlatforms: string[];
  setSelectedPlatforms: (v: string[]) => void;
  techLoading?: boolean;
  productTypeLoading?: boolean;
  platformLoading?: boolean;
}

export default function ProviderFilterBar(props: ProviderFilterBarProps) {
  return (
    <LazySection minHeight={60}>
      <div className="w-full mb-6">

        
        {/* Filter Grid - Two rows of 2 filters each */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          <MultiSelect
            options={props.countryOptions.map((country) => ({ label: country, value: country }))}
            selected={props.selectedCountries}
            onChange={props.setSelectedCountries}
            placeholder="Location"
            disabled={false}
          />
          <MultiSelect
            options={props.technologyOptions.map((tech) => ({ label: tech.name, value: tech.id }))}
            selected={props.selectedTechnologies}
            onChange={props.setSelectedTechnologies}
            placeholder="Technology"
            disabled={props.techLoading}
          />
          <MultiSelect
            options={props.productTypeOptions.map((type) => ({ label: type.name, value: type.id }))}
            selected={props.selectedProductTypes}
            onChange={props.setSelectedProductTypes}
            placeholder="Product Types"
            disabled={props.productTypeLoading}
          />
          <MultiSelect
            options={props.platformOptions.map((platform) => ({ label: platform.name, value: platform.id }))}
            selected={props.selectedPlatforms}
            onChange={props.setSelectedPlatforms}
            placeholder="Platforms"
            disabled={props.platformLoading}
          />
        </div>
      </div>
    </LazySection>
  );
} 